import Event from './Event';
import EventFetcher from './EventFetcher';

export default function EventContainer(props) {
    const event = props.data;

    if (event == null) {
        return null;
    }

    return (
        <EventFetcher data={event} renderItem={data =>
                <Event data={{...event, ...data}} />
            }
        />
    );
}
